import { Spacing } from '@persona-id/design-tokens';
import { ComponentPropsWithoutRef, useState } from 'react';
import styled from 'styled-components';

import { SECONDS_IN_A_DAY } from 'dashboard/forms/FormReportTemplate/RecurringIntervalInput/isValidRecurringInterval';
import TimeIntervalInput, {
  TimeIntervalInputUnit,
} from 'dashboard/forms/FormReportTemplate/RecurringIntervalInput/TimeIntervalInput';
import { Span } from 'design-system/components/Text';
import ToggleSlider from 'design-system/components/ToggleSlider';

interface RecurringIntervalInputProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange' | 'value'> {
  error?: string;
  isDirty?: boolean;
  recurringEnabled?: boolean;
  onChange?: (value: number) => void;
  value?: number;
}

export const RecurringIntervalInput = ({
  id,
  name,
  disabled,
  value,
  onChange,
  onBlur,
  isDirty,
}: RecurringIntervalInputProps) => {
  const [recurringEnabled, setRecurringEnabled] = useState<boolean>(value != null);

  return (
    <FormGroup>
      {recurringEnabled && (
        <>
          <Span color={disabled ? 'disabled' : 'primary'}>Every</Span>
          <TimeIntervalInput
            id={id}
            name={name}
            min='0'
            disabled={!recurringEnabled || disabled}
            value={value}
            unit={TimeIntervalInputUnit.SECONDS}
            isDirty={isDirty}
            onChange={onChange}
            onBlur={onBlur}
          />
        </>
      )}
      <StyledToggleSlider
        id={`${id}_toggle`}
        data-test={`${id}_toggle`}
        disabled={disabled}
        labelOn='Enabled'
        labelOff='Disabled'
        value={recurringEnabled}
        onChange={() => {
          const newValue = !recurringEnabled;
          setRecurringEnabled(newValue);
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          onChange(newValue ? SECONDS_IN_A_DAY * 7 : null);
        }}
      />
    </FormGroup>
  );
};

const FormGroup = styled.div`
  margin-left: auto;
  display: grid;
  grid-template-columns: 45px 1fr 135px;
  grid-gap: ${Spacing[2]} ${Spacing[4]};
  align-items: center;
  min-height: ${({ theme }) => theme.element.height.md};
`;

const StyledToggleSlider = styled(ToggleSlider)`
  grid-column: 3;
`;
